import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setName } from '../redux/modules/layout';

function HelloClient() {
    const name = useSelector(state => state.layout.name);
    const dispatch = useDispatch();

    return (
        <div className="hello">
            <div className="hello__greeting">Hello, {name}!</div>
            <div className="asc-form-group">
                <label htmlFor="input-name" className="asc-form-label">Name</label>
                <input className="asc-form-input" id="input-name" type="text" value={name} onChange={event => dispatch(setName(event.target.value))} />
            </div>
            <div className="hello__description">This component was rendered on the client.</div>
        </div>
    );
}

export default HelloClient;
